import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { getHotArticles, formatDate, formatViews } from '@/utils/articles';

const PERIODS = [
  { key: 'today', label: '今日排行', days: 1 },
  { key: 'week', label: '近七日', days: 7 },
  { key: 'month', label: '近30日', days: 30 },
];

export default function HotPage() {
  const [period, setPeriod] = useState('today');

  useDocumentTitle({
    title: '热门爆料排行榜 - 91黑料网',
    description:
      '91黑料网热门爆料排行榜，按浏览量实时汇总今日、近七日与近30日最受关注的娱乐黑料、明星爆料与社会热点新闻。',
    keywords: '热门爆料,黑料排行榜,91黑料网,明星爆料,社会热点,最新爆料',
  });

  const days = PERIODS.find((p) => p.key === period)?.days ?? 1;
  const list = getHotArticles(undefined, days);
  const maxViews = list.length > 0 ? list[0].views : 1;

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main className="mx-auto max-w-[1280px] px-4 py-6 md:px-6">
        <Breadcrumb items={[{ label: '热门爆料排行' }]} />

        <header className="mt-4 animate-fade-up rounded-lg border border-background-200 bg-foreground-950 p-6 md:p-8">
          <div className="flex items-center gap-3">
            <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-2xl"></i>
            </span>
            <div>
              <h1 className="text-xl font-black text-background-50 md:text-2xl">
                热门爆料排行榜
              </h1>
              <p className="mt-1 text-sm text-background-400">
                按浏览量实时统计，看看大家此刻都在关注什么
              </p>
            </div>
          </div>
        </header>

        <div className="mt-5 flex flex-wrap items-center gap-2 rounded-lg border border-background-200 bg-background-50 p-3 md:p-4">
          {PERIODS.map((p) => (
            <button
              key={p.key}
              type="button"
              onClick={() => setPeriod(p.key)}
              className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                period === p.key
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-secondary-100 text-secondary-900 hover:bg-secondary-200'
              }`}
            >
              {p.label}
            </button>
          ))}
          <span className="ml-auto text-xs text-foreground-400">共 {list.length} 条上榜爆料</span>
        </div>

        <div className="mt-5 flex flex-col gap-3">
          {list.map((item, idx) => (
            <Link
              key={item.id}
              to={`/detail/${item.id}`}
              className="group flex cursor-pointer gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 hover:bg-background-100 md:p-4"
            >
              <span
                className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md font-label text-lg font-bold md:h-12 md:w-12 ${
                  idx < 3
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {idx + 1}
              </span>

              <span className="hidden h-24 w-32 shrink-0 overflow-hidden rounded-md bg-background-200 sm:block md:h-28 md:w-44">
                <img
                  src={item.cover}
                  alt={item.title}
                  title={`${item.title} - 91黑料网`}
                  className="h-full w-full object-top"
                />
              </span>

              <span className="flex min-w-0 flex-1 flex-col">
                <span className="clamp-2 text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
                  {item.title}
                </span>
                <span className="clamp-2 mt-1.5 hidden text-xs leading-relaxed text-foreground-500 sm:block">
                  {item.excerpt}
                </span>
                <span className="mt-auto flex flex-wrap items-center gap-x-3 gap-y-1 pt-2 text-xs text-foreground-400">
                  <span className="flex items-center gap-1 text-accent-600">
                    <i className="ri-eye-line"></i>
                    {formatViews(item.views)} 浏览
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-price-tag-3-line"></i>
                    {item.category}
                  </span>
                  <span className="hidden items-center gap-1 sm:flex">
                    <i className="ri-time-line"></i>
                    {formatDate(item.publishTime).slice(0, 10)}
                  </span>
                </span>
                <span className="mt-2 hidden h-1 w-full max-w-full overflow-hidden rounded-full bg-background-200 md:block">
                  <span
                    className="block h-full rounded-full bg-primary-400"
                    style={{ width: `${Math.round((item.views / maxViews) * 100)}%` }}
                  ></span>
                </span>
              </span>
            </Link>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
}